import { AnonymousUserToken } from '../../AnonymousUserToken';

export class AmplifyAnonymousUserToken extends AnonymousUserToken {
    constructor(public authData) {
        super();
    }
}
